import {LocalDate} from "./localDate";
import {HTML5DateExpression} from "./parseDate";
import {isString} from "../../../bootstrap/common/strings";
import type {Maybe} from "../../../bootstrap/common/types";

export function date(inputDate: Maybe<Date | LocalDate | string>): LocalDate {
    if (inputDate instanceof LocalDate) {
        return inputDate.clone();
    } else if (isDate(inputDate)) {
        return LocalDate.fromDate(inputDate);
    } else if (isString(inputDate)) {
        return LocalDate.fromDateExpression(inputDate) ?? LocalDate.invalid();
    } else {
        return LocalDate.invalid();
    }
}

export function parseHtml5Date(inputString: string): Maybe<Date> {
    const ymd = HTML5DateExpression.parse(inputString);
    if (!ymd) {
        return undefined;
    }
    return ymd.toLocalDate().toDate();
}

export function formatHtml5Date(inputDate: Date): Maybe<string> {
    return LocalDate.fromDate(inputDate).toHtml5DateString();
}

export function isDate(value: unknown): value is Date {
    return Object.prototype.toString.call(value) === "[object Date]";
}

export function isSameDay(left: Date, right: Date): boolean {
    return left.getFullYear() === right.getFullYear()
        && left.getMonth() === right.getMonth()
        && left.getDate() === right.getDate();
}

export function isSameYear(left: Date, right: Date): boolean {
    return left.getFullYear() === right.getFullYear();
}